import { Component } from "@angular/core";
import { DatetimeTableColumn } from "../custom-table-column/datetime-table-column";
import { CustomTableValueComponent } from "./abstract-custom-table-value.component";

@Component({
    selector: 'datetime-table-value',
    template: '<span [ngClass]="getClass()">{{ getValue() | datetime:column.format }}</span>'
})
export class DatetimeTableValueComponent extends CustomTableValueComponent<DatetimeTableColumn> {
}